import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Progress,
  Row,
  Spinner,
} from "reactstrap";
import * as Yup from "yup";

//import images
import { UploadProps } from "antd";
import {
  getBarDetail,
} from "store/bar-list/thunk";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import { COLOR_BAR_DETAIL_REVIEW_STATUS, COLOR_BAR_LIST_OPEN_STATUS, COLOR_STICKER_PACKAGE_TYPE, LIST_OPTION_BAR_DETAIL_REVIEW_STATUS, LIST_OPTION_BAR_LIST_OPEN_STATUS, STICKER_PACKAGE_TYPE_OPTION } from "helpers/constans";
import UploadImageSingle from "components/Common/UploadImageSingle";
import { postPackageSticker, putPackageSticker } from "store/sticker/thunk";

export interface Props {
  id?: string;
  isCopy?: boolean;
  triggerRefresh?: () => void;
  isShowDetail?: boolean;
  setLinkImage?: any;
  setIsOpen?: any;
  setItemToEdit?: any;
}

registerLocale("en", en);
registerLocale("ko", ko);

const uploadProps: UploadProps = {
  name: "files",
  accept: "image/png,image/jpeg,image/*",
  beforeUpload: () => false,
  headers: {
    authorization: "authorization-text",
  },
};

const FormPackage = ({
  id = "",
  triggerRefresh,
  isShowDetail = false,
  setLinkImage,
  setIsOpen,
  setItemToEdit,
}: Props) => {
  const { t, i18n } = useTranslation();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingDetail, setIsLoadingDetail] = useState<boolean>(false);

  const handleSubmit = async (values: any) => {
    try {
      setIsLoading((_prev) => true);
      const data = {
        name: values?.name,
        description: values?.description,
        type: values?.type,
        thumbnailUrl: values?.thumbnailUrl,
        status: values?.status
      };
      
      const response: any = id
        ? await putPackageSticker(id, data)
        : await postPackageSticker(data);

      if (response?.data) {
        setIsLoading((_prev) => false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
        triggerRefresh && triggerRefresh();
      } else {
        setIsLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const validationSchema = Yup.object({
    name: Yup.string().required(`${t("Name is required")}`),
    // thumbnailUrl: Yup.string().required(`${t("Image is required")}`),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      status: 1,
      type: 0,
      thumbnailUrl: null
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  const handleSetValueForm = (valueDefault: any) => {
    formik.setValues(valueDefault);
  };

  const handleCallBarDetail = async (idItem: string) => {
    try {
      if (!idItem) {
        return;
      }
      setIsLoadingDetail((_prev) => true);
      const resDetail: any = await getBarDetail(idItem);

      if (resDetail?.data) {
        handleSetValueForm(resDetail?.data);
        setIsLoadingDetail((_prev) => false);
      }
    } catch (error: any) {
      setIsLoadingDetail((_prev) => false);
      return error;
    }
  };

  const onCloseClick = () => {
    setIsOpen(false);
    setItemToEdit(false);
  };

  useEffect(() => {
    handleCallBarDetail(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    document.title = `${t("Create Package")} - ${t("Sticker Management")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <Modal isOpen={true} centered={true} scrollable={false} size="l">
        <ModalHeader toggle={isLoading ? () => {} : onCloseClick}>
          {id ? t("Button Update Package") : t("Button Create Package")}
        </ModalHeader>
        <ModalBody className="py-3 px-4">
          <div className="mb-4">
            <Progress
              value={
                100 - (100 / 2) * Number(Object.keys(formik.errors).length)
              }
              color="primary"
              className="animated-progress progress-sm"
            />
          </div>

          <div className="mt-3">
            <>
              {isLoadingDetail && (
                <div
                  style={{
                    position: "absolute",
                    zIndex: 3,
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    backgroundColor: "rgb(164 164 164 / 36%)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Spinner size="sm" color="primary"></Spinner>
                </div>
              )}
              <form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={12}>
                    <div className="mb-3">
                      <Label htmlFor="name-bar" className="form-label">
                        {t("Name")} <span className="text-danger">*</span>
                      </Label>
                      <Input
                        id="name-bar"
                        name="name"
                        type="text"
                        className="form-control"
                        placeholder={t("Enter your name")}
                        value={formik?.values?.name}
                        onChange={(event: any) =>
                          formik.setFieldValue("name", event?.target?.value)
                        }
                      />
                      {formik.touched.name && formik.errors.name ? (
                        <div className="text-danger mt-2">
                          {formik.errors.name}
                        </div>
                      ) : null}
                    </div>
                  </Col>
                  
                  <Col lg={12}>
                    <div className="mb-3">
                      <Label className="form-label">
                        {t("Type")}
                      </Label>

                      <DropdownStatusNew
                        name="type"
                        dataList={STICKER_PACKAGE_TYPE_OPTION || []}
                        placeholder={`${t("Type")}...`}
                        className="dropdown-status-rounded"
                        classNamePrefix="name-prefix"
                        initialValue={formik?.values?.type}
                        onChangeSelect={(event: any) =>
                          formik.setFieldValue("type", event?.value)
                        }
                        isHasOptionAll={false}
                        optionAll={{ label: t("All Filter"), value: "" }}
                        colors={COLOR_STICKER_PACKAGE_TYPE}
                      />
                      {formik?.touched?.type && formik?.errors?.type ? (
                        <div className="text-danger mt-2">
                          {/* {formik?.errors?.plan} */}
                        </div>
                      ) : null}
                    </div>
                  </Col>

                  <Col lg={12}>
                    <div className="mb-3">
                      <Label className="form-label">
                        {t("Status")}
                      </Label>

                      <DropdownStatusNew
                        name="status"
                        dataList={LIST_OPTION_BAR_DETAIL_REVIEW_STATUS || []}
                        placeholder={`${t("Status")}...`}
                        className="dropdown-status-rounded"
                        classNamePrefix="name-prefix"
                        initialValue={formik?.values?.status}
                        onChangeSelect={(event: any) =>
                          formik.setFieldValue("status", event?.value)
                        }
                        isHasOptionAll={false}
                        optionAll={{ label: t("All Filter"), value: "" }}
                        colors={COLOR_BAR_DETAIL_REVIEW_STATUS}
                      />

                      {formik?.touched?.status && formik?.errors?.status ? (
                        <div className="text-danger mt-2">
                          {/* {formik?.errors?.status} */}
                        </div>
                      ) : null}
                    </div>
                  </Col>

                  <Col xxl={12} className="date-picker-wrapper-custom mt-3 mt-md-2">
                    <div className="mb-3">
                      <Label className="form-label">{t("Description")}</Label>

                      <textarea
                        className="form-control"
                        name="description"
                        value={formik?.values?.description}
                        placeholder={`${t("Please enter your description")}...`}
                        onChange={(event: any) =>
                          formik.setFieldValue("description", event?.target?.value || "")
                        }
                        style={{ height: 80 }}
                      />
                    </div>
                  </Col>

                  <Col xxl={12}>
                    <label className="form-label">
                      {t("Thumbnail")}
                    </label>

                    <UploadImageSingle
                      data={formik.getFieldProps("thumbnailUrl")?.value}
                      setLinkImage={setLinkImage}
                      formik={formik}
                      isMultiple={false}
                      uploadProps={uploadProps}
                      formikNameImage={"thumbnailUrl"}
                    />
                  </Col>
                  
                  <Col lg={12}>
                    <div className="hstack gap-2 justify-content-end">
                      {!isShowDetail && (
                        <button type="submit" className="btn btn-primary fs-14">
                          {isLoading ? (
                            <Spinner size="sm" className="me-2"></Spinner>
                          ) : !!id ? (
                            <i className="ri-login-circle-line align-bottom me-2 "></i>
                          ) : (
                            <i className="ri-add-fill align-bottom me-2"></i>
                          )}
                          {id ? t("Button Update") : t("Button Create")}
                        </button>
                      )}
                    </div>
                  </Col>
                </Row>
              </form>
            </>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default FormPackage;
